// extracted by mini-css-extract-plugin
module.exports = {"captchaImg":"captchaImg___3cpyl","loginBox":"loginBox___2mqhR","loginForm":"loginForm___Vd0sQ","videoBox":"videoBox___17klz"};